import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardLayoutComponent } from 'src/app/shared/layout/dashboard-layout/component/dashboard-layout.component';
import {accessTokenGuard} from "../../core/guards/access-token.guard";
import {EAccessType} from "../../core/enums/access-type.enum";
import {EAdminPermission} from "../../core/enums/admin-permission.enum";

const routes: Routes = [
  {
    path: '',
    component: DashboardLayoutComponent,
    canActivate: [accessTokenGuard],
    data: { allowedAccessToken: EAccessType.FAT,},
    children: [
      {
        path: 'subscriptions',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_SUBSCRIPTIONS},
        loadChildren: () =>
          import('./modules/subscription/subscription.module').then(
            ({ SubscriptionModule }) => SubscriptionModule),
      },
      {
        path: 'providers',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_USERS},
        loadChildren: () =>
          import('./modules/providers/providers.module').then(
            ({ ProvidersModule }) => ProvidersModule),
      },
      {
        path: 'recipients',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_USERS},
        loadChildren: () =>
          import('./modules/recipients/recipients.module').then(
            ({ RecipientsModule }) => RecipientsModule),
      },
      {
        path: 'accounts',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_USERS},
        loadChildren: () =>
          import('./modules/accounts/accounts.module').then(
            ({ AccountsModule }) => AccountsModule),
      },
      {
        path: 'applications',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_APPLICATIONS},
        loadChildren: () =>
          import('./modules/applications/applications.module').then(
            ({ ApplicationsModule }) => ApplicationsModule),
      },
       {
        path: 'transactions',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_TRANSACTIONS},
        loadChildren: () =>
          import('./modules/transactions/transactions.module').then(
            ({ TransactionsModule }) => TransactionsModule),
      },
       {
        path: 'masri-info-report',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_MASRI_CREDIT_REPORTS},
        loadChildren: () =>
          import('./modules/masri-credit-report/masri-credit-report.module').then(
            ({ MasriCreditReportModule }) => MasriCreditReportModule),
      },
      {
        path: 'ratings',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_RATINGS},
        loadChildren: () =>
          import('./modules/ratings/ratings.module').then(
            ({ RatingsModule }) => RatingsModule),
      },
      {
        path: 'payments',
        canActivate: [accessTokenGuard],
        data: {requiredPermissions: EAdminPermission.LIST_PAYMENT_TRANSACTIONS},
        loadChildren: () =>
          import('./modules/payments/payments.module').then(
            ({ PaymentsModule }) => PaymentsModule),
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManagementRoutingModule { }
